import { useState, useEffect } from 'react';
import { get, getDatabase, ref } from 'firebase/database';
import { BuildingSummary } from "../types/protocols";

export const useBuildingsData = () => {
    const [buildings, setBuildings] = useState<BuildingSummary[] | undefined>(undefined);
    const [loadingSummaries, setLoadingSummaries] = useState<boolean>(true);
    const [summariesError, setSummariesError] = useState<Error | null>(null);

    const fetchBuildings = async () => {
        setLoadingSummaries(true);
        setSummariesError(null);

        try {
            const db = getDatabase();
            const buildingsRef = ref(db, 'buildingsSummary');
            const snapshot = await get(buildingsRef);

            if (snapshot.exists()) {
                const data = snapshot.val() as { [key: string]: BuildingSummary };
                const buildingPromises = Object.entries(data).map(async ([key, buildingData]) => {
                    return {...buildingData} as BuildingSummary;
                });

                const buildingsArray = await Promise.all(buildingPromises);
                setBuildings(buildingsArray);
            } else {
                console.log('No buildings data available in the snapshot');
                setBuildings([]);
            }
        } catch (err) {
            console.error('Failed to load building data', err);
            setSummariesError(err instanceof Error ? err : new Error('Unknown error'));
        } finally {
            setLoadingSummaries(false);
        }
    };

    useEffect(() => {
        fetchBuildings();
    }, []);

    return {
        buildings,
        loadingSummaries,
        summariesError,
        refreshBuildings: fetchBuildings
    };
};